export default "__VITE_ASSET__CIh9uyMM__"